import React from "react";
import { Link } from "react-router-dom";
import { Jumbotron, Container } from "reactstrap";

const NotFound = () => (
  <Container>
    <Jumbotron>
      <h1>404 Not found!</h1>
      <Link to="/">Go Back</Link>
    </Jumbotron>
  </Container>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound.js